import { FC, forwardRef } from "react";
import SubFolderSvg from "../../public/icons/SubFolder.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const SubFolderIcon: FC<IconProps> = forwardRef(
  function SubFolderIcon(iconProps, ref) {
    return <span role="img" ref={ref} {...useAddMissingAntIconClass(iconProps)}><SubFolderSvg/></span>;
  },
);
